export const aiAnsweringCustomModuleName = "Shared Topics Module";
export const aiAnsweringCommonAppName = "Shared Topics";